import React from 'react';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa6';

const faqs = [
	{
		question: 'What happens after my trial ends?',
		answer: 'You would get grace period of 15 minutes following which Your account will automatically switch to the started plan unless you choose to upgrade.',
	},
	{
		question: 'Can I change my plan later?',
		answer: 'Absolutely! You can upgrade, downgrade, or cancel your plan anytime.',
	},
	{
		question: 'Are there any setup fees?',
		answer: 'Yes, implementation charges are applicable for Pro and Enterprise.',
	},
	{
		question: 'What payment methods do you accept?',
		answer: 'We accept major credit cards, debit cards, and bank transfers. Contact us for custom billing needs.',
	},
	{
		question: 'Is my data secure?',
		answer: 'Yes, we use industry-standard encryption and follow strict security protocols to keep your data safe.',
	},
	{
		question: 'Do you offer discounts for annual plans?',
		answer: 'Yes! Save up to 20% by switching to an annual subscription.',
	},
	{
		question: 'Can I get a refund if I cancel my subscription?',
		answer: 'We offer a 30-day money-back guarantee if you’re not satisfied.',
	},
	{
		question: 'Do you offer support for setup or onboarding?',
		answer: 'Yes, our team provides onboarding assistance to ensure a smooth start with our platform for Pro and Enterprise customers. For Starter plan we provide video tutorials ',
	},
	{
		question: 'What happens if I exceed  plan limits?',
		answer: 'We’ll notify you, and you can either upgrade or pay for additional usage.',
	},
	{
		question: 'Can I add more users to my plan?',
		answer: 'Yes, you can add additional users anytime—pricing scales accordingly. For Pro and Enterprise Customers we provide unlimited users.',
	},
	{
		question: 'Is there a contract or long-term commitment?',
		answer: 'No contracts! You can cancel anytime without penalties.',
	},
	{
		question: 'Do you offer custom pricing for enterprises?',
		answer: 'Yes, we provide tailored solutions for larger teams. Reach us out at sales@assetze.com',
	},
	{
		question: 'How do I contact support?',
		answer: 'Our support team is available via email at support@assetze.com',
	},
];

function PricingFaq() {
	const [isSelected, setSelected] = React.useState(null);
	return (
		<div className="pricing-faq-container">
			<div className="head">Pricing FAQ</div>
			<div className="faq-list">
				{faqs.map((el, index) => (
					<div key={index} className="each-faq">
						<div className="faq-item" onClick={() => setSelected(index)}>
							<div className="faq-question">
								<div>{el.question}</div>
								{isSelected === index ? <FaAngleDown /> : <FaAngleUp />}
							</div>
							{isSelected === index ? <div className="faq-answer">{el.answer}</div> : null}
						</div>
					</div>
				))}
			</div>
		</div>
	);
}

export default PricingFaq;
